var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "auth-section" },
    [
      _c("div", { staticClass: "form-wrapper" }, [
        _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "input-title" }, [
              _c("h2", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.type === "login"
                        ? "auth.login.welcome"
                        : "auth.signup.welcome"
                    )
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.type === "login"
                        ? "auth.login.subtitle"
                        : "auth.signup.subtitle"
                    )
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "auth-switch" }, [
              _c("div", { staticClass: "auth-toggle" }, [
                _c("div", {
                  staticClass: "toggle-slider",
                  class: { "slide-right": _vm.type === "signup" },
                }),
                _c(
                  "button",
                  {
                    class: ["toggle-btn", { active: _vm.type === "login" }],
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.display("login")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("auth.login.title")) +
                        "\n          "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    class: ["toggle-btn", { active: _vm.type === "signup" }],
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.display("signup")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("auth.signup.title")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
            _c("component-form", {
              attrs: { authType: this.type },
              on: {
                "submit-clicked": _vm.submit,
                "forgot-clicked": _vm.forgot,
              },
            }),
            _c("component-social", {
              on: {
                "facebook-connected": _vm.createFacebook,
                "linkedin-connected": _vm.createLinkedin,
              },
            }),
            _c("div", { staticClass: "login-link" }, [
              _c("p", [
                _c(
                  "a",
                  {
                    staticClass: "underline legal",
                    attrs: { href: "/#/legal", target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.$t("dash.header.nav.legal")))]
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm.confirmRegister
          ? _c("img", {
              attrs: {
                src: "https://ct.capterra.com/capterra_tracker.gif?vid=2157106&vkey=cacb528208ed853298cc3fe4045c7759",
              },
            })
          : _vm._e(),
      ]),
      _c("component-carousel", { attrs: { authType: this.type } }),
      _c("LoadingOverlay", { attrs: { show: _vm.isLoading } }),
      _c("CustomModal", {
        attrs: {
          show: _vm.dialog.show,
          title: _vm.dialog.title,
          message: _vm.dialog.message,
        },
        on: { close: _vm.hideDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }